/**
 * Light pollution tile configuration.
 *
 * Tiles served via Cloudflare Worker from Backblaze B2.
 * Worker extracts individual tiles from PMTiles archive and caches at edge.
 * PMTiles range requests are also proxied through the Worker so CORS is
 * handled centrally rather than relying on B2 bucket CORS config.
 */

/** Tile URL for Leaflet TileLayer — simple GET requests, fully cacheable */
export const TILE_SERVER_URL =
  import.meta.env.VITE_TILE_SERVER_URL ||
  'https://tiles.milkywayplanner.com/{z}/{x}/{y}.png';

/** PMTiles URL for client-side Bortle lookups (range requests proxied via Cloudflare Worker) */
export const PMTILES_URL =
  import.meta.env.VITE_PMTILES_URL ||
  'https://tiles.milkywayplanner.com/tiles/alr_v2.pmtiles';

// ?v=web busts the Cloudflare edge cache that held the old 64 MB full file
// so the Worker serves the simplified 16 MB web version instead.
export const DARK_SKY_GEOJSON_URL =
  import.meta.env.VITE_DARK_SKY_GEOJSON_URL ||
  'https://tiles.milkywayplanner.com/dark-sky-places.geojson?v=web';

/** Zoom level used for Bortle class sampling (matches tile generation) */
export const BORTLE_SAMPLE_ZOOM = 8;

/** Valid tile zoom range */
export const TILE_ZOOM_MIN = 3;
export const TILE_ZOOM_MAX = 12;
